export default __webpack_public_path__ + "assets/img/single-post-ex2.png";